<template>
  <div class="space-y-8 text-center">
    <div class="space-y-4">
      <h2 class="text-3xl font-bold text-base-content leading-tight">
        {{ $t("smartLeadForm.start.title") }}
      </h2>
      <p class="text-base-content/70 leading-relaxed">
        {{ $t("smartLeadForm.start.desc") }}
      </p>
    </div>
    
    <button @click="$emit('next')" class="btn btn-primary btn-lg w-full rounded-xl font-medium">
      {{ $t("smartLeadForm.start.cta") }}
    </button>
    
    <p class="text-sm text-base-content/50 font-medium">
      {{ $t("smartLeadForm.start.note") }}
    </p>
  </div>
</template>
